import { render, staticRenderFns } from "./leadsDashboard.vue?vue&type=template&id=364382c4"
import script from "./leadsDashboard.vue?vue&type=script&lang=js"
export * from "./leadsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports